import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css"; // core Swiper styles
import "swiper/css/navigation"; 
import "swiper/css/pagination";
import "../assets/swiper-custom.css"
import OffCanvasMenu from "./offcanvas";
import Nav from "./mob-nav";



import { Navigation, Pagination } from "swiper/modules";

export default function LucyYak() {

const [showOffCanvas, setShowOffCanvas] = useState(false);

const toggleOffCanvas = () => {
    setShowOffCanvas(!showOffCanvas);
};

  return (
    <div style={styles.container}>

    
      {/* Hero Banner */}
      <section style={styles.hero}>
        <div className="flex justify-between items-center border-b border-gray-200">
            <img
            src="images/logo-ly.png"
            alt="Lucy and Yak logo"
            style={styles.logo}
            />

            <div className="container flex items-center">
                <div className="dropdown bottom-border flex items-center">
                    <button className="dropbtn flex items-center justify-left">
                        <span className="font-bold uppercase text-xs lg:text-sm">Shop</span>
                        <img src="images/down.svg" aria-label="down arrow" alt="down arrow" className="ml-2 w-3 h-3"/>
                    </button>
                    <div className="dropdown-content p-6">
                        <h3 className="p-4 mb-6 justify-start text-left font-bold text-lg">New In &<br/> Featured</h3>
                        <a href="/lucy" className="text-sm">New In</a>
                        <a href="/lucy" className="text-sm">Best Sellers</a>
                        <a href="/lucy" className="text-sm">Limited Editions</a>
                        <a href="/lucy" className="text-sm">Iconic Prints</a>
                        <a href="/lucy" className="text-sm">Essentials</a>
                        <a href="/lucy" className="text-sm">Back In Stock</a>
                        <a href="/lucy" className="text-sm">Petite Range</a>
                        <a href="/lucy" className="text-sm">Tall Range</a>
                        <a href="/lucy" className="text-sm workwear">Workwear</a>
                        <a href="/lucy" className="text-sm">Last Chance</a>
                        <a href="/lucy" className="text-sm neutral">Neutral Collection</a>
                    </div>
                </div> 
                <a href="/lucy" className="bottom-border"><span className="font-bold uppercase text-xs lg:text-sm">Community</span>
                </a>
                <div className="dropdown bottom-border flex items-center">
                    <button className="dropbtn flex items-center justify-left">
                        <span className="font-bold uppercase text-xs lg:text-sm">Sustainability</span>
                        <img src="images/down.svg" aria-label="down arrow" alt="down arrow" className="ml-2 w-3 h-3"/>
                    </button>
                    <div className="dropdown-content p-6">
                        <a href="/lucy" className="text-sm">Our Mission</a>
                        <a href="/lucy" className="text-sm">Our Impact</a>
                        <a href="/lucy" className="text-sm">Our Fabrics</a>
                    </div>
                </div> 
                <a href="/lucy" className="pastel-link text-xs lg:text-sm no-wrap">Neutral Collection</a>
            </div>

            <img
            src="images/right-content.png"
            alt="Lpgin etc"
            style={styles.right}
            className="right-content"
            />
            <span onClick={(toggleOffCanvas)} className="absolute z-100 top-4 right-4 pointer-events-auto md:hidden">
                <button className="w-8 h-8 cursor-pointer" >
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 12H20" stroke="#000000" strokeWidth="2" strokeLinecap="round"/>
                        <path d="M5 17H20" stroke="#000000" strokeWidth="2" strokeLinecap="round"/>
                        <path d="M5 7H20" stroke="#000000" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                </button>
            </span>

            {showOffCanvas && (
                <OffCanvasMenu
                title="Lucy & Yak Menu"
                width="w-[80%]"
                postition="left-0" /* Use 'left-0' to position the offcanvas menu to the left. */
                component={<Nav toggleOffCanvas={toggleOffCanvas} />}
                onRequestClose={toggleOffCanvas}
                className="transition delay-150 duration-300 ease-in-out"
                />
            )}
            
        </div>
        <div style={styles.headerOverlay}>
            <img
                src="images/lucy-header.png"
                alt="The Neutral Capsule Collection"
                aria-label="The Neutral Capsule Collection"
                style={styles.heroImage}
            />
            <h1 style={styles.heading}>The Neutral Collection</h1>
        </div>
        
      </section>

      {/* Intro Section */}
      <section style={styles.intro}>
        
        <p style={styles.text}>
          A sustainable collection designed with our signature shapes in subtle,
          timeless tones. Minimalist design, maximum impact.
        </p>
      </section>

      {/* Swiper Product Carousel */}
      <section style={{ padding: "40px 20px" }}>
        <h2 style={styles.subHeading}>Featured Pieces</h2>
        <Swiper
          modules={[Navigation, Pagination]}
          spaceBetween={16}
          navigation
          pagination={{ clickable: true }}
          breakpoints={{
            0: { slidesPerView: 1.2 },     // phones
            600: { slidesPerView: 2 },     // tablets
            1024: { slidesPerView: 3 },    // desktops
          }}
          grabCursor={true}
          style={{ paddingBottom: "40px" }}
        >
          <SwiperSlide>
            <div style={styles.card}>
                <div className="relative">
                    <img src="images/lucy-1.png" className="cursor-pointer scale-100 hover:scale-120" aria-label="Neutral Patterned Fleece" alt="Neutral Patterned Fleece" style={styles.cardImg} />
                    <p className="absolute bottom-0 text-xs text-black bg-orange-100 py-2 w-full">100% ORGANIC COTTON</p>
                </div>  
              
              <h3 style={styles.cardTitle}>Neutral Patterned Fleece</h3>
              <p style={styles.cardText}>Soft organic cotton in Green Check</p>
              <p style={styles.price}>£55.00</p>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div style={styles.card}>
                <div className="relative">
                    <img src="images/lucy-2.png" className="cursor-pointer scale-100 hover:scale-120" aria-label="Neutral Patterned Shirt" alt="Neutral Patterned Shirt" style={styles.cardImg} />
                    <p className="absolute bottom-0 text-xs text-black bg-orange-100 py-2 w-full">100% ORGANIC COTTON</p>
              </div>
              <h3 style={styles.cardTitle}>Neutral Patterned Shirt</h3>
              <p style={styles.cardText}>Relaxed fit, everyday comfort</p>
              <p style={styles.price}>£45.00</p>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div style={styles.card}>
                <div className="relative">
                    <img src="images/lucy-3.png" className="cursor-pointer scale-100 hover:scale-120" aria-label="Neutral Patterned Dress" alt="Neutral Patterned Dress" style={styles.cardImg} />
                    <p className="absolute bottom-0 text-xs text-black bg-orange-100 py-2 w-full">100% ORGANIC COTTON</p>
                </div>
              
              <h3 style={styles.cardTitle}>Neutral Patterned Dress</h3>
              <p style={styles.cardText}>Classic Lucy & Yak style in soft tones</p>
              <p style={styles.price}>£50.00</p>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div style={styles.card}>
                <div className="relative">
                    <img src="images/lucy-4.png" className="cursor-pointer scale-100 hover:scale-120" aria-label="Neutral Patterned Shirts" alt="Neutral Patterned Shirts" style={styles.cardImg} />
                    <p className="absolute bottom-0 text-xs text-black bg-orange-100 py-2 w-full">100% ORGANIC COTTON</p>
                </div>
              
              <h3 style={styles.cardTitle}>Neutral Patterned Shirts</h3>
              <p style={styles.cardText}>Relaxed fit, everyday comfort</p>
              <p style={styles.price}>from £35.00</p>
            </div>
          </SwiperSlide>

        </Swiper>
      </section>

      {/* Call to Action */}
      <section style={styles.cta}>
        <h2 style={styles.ctaHeading}>Discover the Collection</h2>
        <button style={styles.ctaButton}>Shop Now</button>
      </section>
    </div>
  );
}

// Inline Styles
const styles = {
  container: {
    fontFamily: "Poppins, sans-serif",
    color: "#333",
    margin: 0,
    padding: 0,
    textAlign: "center",
  },
  hero: {
    width: "100%",
    overflow: "hidden",
    backgroundPosition: "top",
  },
  logo: {
    height: "80px",
  },
  right: {
    height: "80px",
  },
  mob: {
    height: "80px",
  },
  heroImage: {
    width: "100%",
    height: "auto",
    maxHeight: "600px",
    objectFit: "cover",
  },
  headerOverlay: {
    postition: "relative",
    height: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: "images/"
  },
  intro: {
    padding: "30px 15px",
  },
  heading: {
    position: "absolute",
    fontSize: "2.5rem",
    marginBottom: "10px",
    color: "white",
    zIndex: "1",
  },
  subHeading: {
    fontSize: "1.8rem",
    marginBottom: "20px",
  },
  text: {
    maxWidth: "600px",
    margin: "0 auto",
    fontSize: "1.2rem",
    lineHeight: "1.6",
    paddingTop: "2rem",
  },
  card: {
    border: "1px solid #eee",
    borderRadius: "12px",
    padding: "20px",
    background: "#fff",
    textAlign: "center",
  },
  cardImg: {
    width: "100%",
    borderRadius: "8px",
    marginBottom: "10px",
  },
  cardTitle: {
    fontSize: "1.2rem",
    marginBottom: "5px",
    paddingTop: "1rem",
  },
  cardText: {
    fontSize: "0.95rem",
    color: "#555",
    marginBottom: "1rem",
  },
  price: {
    fontSize: "1.2rem",
    color: "#d8b788",
  },
  cta: {
    background: "#f5f5f5",
    padding: "40px 15px",
  },
  ctaHeading: {
    fontSize: "2rem",
    marginBottom: "20px",
  },
  ctaButton: {
    fontSize: "1rem",
    padding: "12px 24px",
    border: "none",
    borderRadius: "8px",
    background: "#333",
    color: "#fff",
    cursor: "pointer",
  },
};
